<template>
  <div class="box-admin mes-client-wrapper col-md-5">
    <blocHeaderTitle
      titre="Création de compte"
      :sous-titre="clientName"
      :icone="['fas', 'user-tie']"
    >
      <b-button
        :to="'/dashboard/create-user/' + $route.params.id"
        variant="outline-primary"
        ><font-awesome-icon :icon="['fas', 'user-plus']" />Nouvel
        utilisateur</b-button
      >
    </blocHeaderTitle>

    <div class="listing-user-wrapper editeur_mode">
      <transition-group name="fade" tag="div" class="tasks__list">
        <blocTypeUser
          bloc-link="#"
          :titre="user.nom + ' ' + user.prenom"
          :sous-titre="user.roles"
          v-for="user in userList"
          :key="user.id"
          :user-id="user.id.toString()"
          :client-id="$route.params.id"
          @delete="handleDeleteClient"
        ></blocTypeUser>
      </transition-group>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import blocTypeUser from '../../components/utils/blocTypeUser'
import blocHeaderTitle from '../../components/utils/blocHeaderTitle'
import { Roles } from '../../utils'
export default {
  components: {
    blocTypeUser,
    blocHeaderTitle
  },
  data () {
    return {
      clientName: '',
      roles: Roles,
      userList: {}
    }
  },
  mounted () {
    this.getUserLists(this.$route.params.id)
    this.getClientName(parseInt(this.$route.params.id, 10))
  },
  methods: {
    ...mapActions(['getUsersByClientId', 'getClients', 'deleteUser']),
    getUserLists (id) {
      this.getUsersByClientId(id).then((resp) => {
        this.userList = resp.map(x => {
          x.roles = this.roles[x.roles]
          return x
        })
      })
    },
    getClientName (id) {
      this.getClients(0).then((resp) => {
        this.clientName = resp.items.filter(x => x.id === id)[0].nom
      }, (err) => {
        this.$toaster.error('getClients: ' + err)
      })
    },
    handleDeleteClient (id) {
      this.deleteUser(id).then(async (res) => {
        this.userList.splice(this.userList.findIndex(x => x.id === parseInt(id, 10)), 1)
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss">
.editeur_mode {
  .user-wrapper {
    height: 70px;
    .action-group {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/listingUserByEditeur/index.vue